// src/reducers/hdfcRetailReducers.js
import {
  GET_ALL_HDFC_RETAIL_REQUEST,
  GET_ALL_HDFC_RETAIL_SUCCESS,
  GET_ALL_HDFC_RETAIL_FAIL,
  IMPORT_HDFC_RETAIL_REQUEST,
  IMPORT_HDFC_RETAIL_SUCCESS,
  IMPORT_HDFC_RETAIL_FAIL,
  EXPORT_HDFC_RETAIL_REQUEST,
  EXPORT_HDFC_RETAIL_SUCCESS,
  EXPORT_HDFC_RETAIL_FAIL,
  UPDATE_HDFC_RETAIL_REQUEST,
  UPDATE_HDFC_RETAIL_SUCCESS,
  UPDATE_HDFC_RETAIL_FAIL,
  DELETE_HDFC_RETAIL_REQUEST,
  DELETE_HDFC_RETAIL_SUCCESS,
  DELETE_HDFC_RETAIL_FAIL,
  BULK_DELETE_HDFC_RETAIL_REQUEST,
  BULK_DELETE_HDFC_RETAIL_SUCCESS,
  BULK_DELETE_HDFC_RETAIL_FAIL,
} from '../constants/hdfcretailConstants';

// Get HDFC Retail Records Reducer
export const getHdfcRetailRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_HDFC_RETAIL_REQUEST:
      return { loadingGetHdfcRetailRecords: true };
    case GET_ALL_HDFC_RETAIL_SUCCESS:
      return {
        loadingGetHdfcRetailRecords: false,
        getHdfcRetailRecordsData: action.payload,
      };
    case GET_ALL_HDFC_RETAIL_FAIL:
      return {
        loadingGetHdfcRetailRecords: false,
        errorGetHdfcRetailRecords: action.payload,
      };
    default:
      return state;
  }
};

// Import HDFC Retail Records Reducer
export const importHdfcRetailReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_HDFC_RETAIL_REQUEST:
      return { loadingImportHdfcRetail: true };
    case IMPORT_HDFC_RETAIL_SUCCESS:
      return {
        loadingImportHdfcRetail: false,
        importHdfcRetailData: action.payload,
      };
    case IMPORT_HDFC_RETAIL_FAIL:
      return {
        loadingImportHdfcRetail: false,
        errorImportHdfcRetail: action.payload,
      };
    default:
      return state;
  }
};


// Export HDFC Retail Records Reducer
export const exportHdfcRetailReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_HDFC_RETAIL_REQUEST:
      return { loadingExportHdfcRetail: true };
    case EXPORT_HDFC_RETAIL_SUCCESS:
      return {
        loadingExportHdfcRetail: false,
        exportHdfcRetailData: action.payload,
      };
    case EXPORT_HDFC_RETAIL_FAIL:
      return {
        loadingExportHdfcRetail: false,
        errorExportHdfcRetail: action.payload,
      };
    default:
      return state;
  }
};


// Update HDFC Retail Record Reducer
export const updateHdfcRetailReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_HDFC_RETAIL_REQUEST:
      return { loadingUpdateHdfcRetail: true };
    case UPDATE_HDFC_RETAIL_SUCCESS:
      return {
        loadingUpdateHdfcRetail: false,
        updateHdfcRetailData: action.payload,
      };
    case UPDATE_HDFC_RETAIL_FAIL:
      return {
        loadingUpdateHdfcRetail: false,
        errorUpdateHdfcRetail: action.payload,
      };
    default:
      return state;
  }
};

// Delete HDFC Retail Record Reducer
export const deleteHdfcRetailReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_HDFC_RETAIL_REQUEST:
      return { loading: true };
    case DELETE_HDFC_RETAIL_SUCCESS:
      return { loading: false, success: true };
    case DELETE_HDFC_RETAIL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Bulk Delete HDFC Retail Records Reducer
export const bulkDeleteHdfcRetailReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_HDFC_RETAIL_REQUEST:
      return { loadingBulkDeleteHdfcRetail: true };
    case BULK_DELETE_HDFC_RETAIL_SUCCESS:
      return {
        loadingBulkDeleteHdfcRetail: false,
        bulkDeleteHdfcRetailData: action.payload,
      };
    case BULK_DELETE_HDFC_RETAIL_FAIL:
      return {
        loadingBulkDeleteHdfcRetail: false,
        errorBulkDeleteHdfcRetail: action.payload,
      };
    default:
      return state;
  }
};

